import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

import Price from '@/checkout-instore-legacy/components/Commons/Price'

const Item = ({
  name,
  imageSrc,
  totalPrice,
  amount,
  showStartingAt,
  router,
  productId,
  skuId,
}) => {
  const goToProductPage = () => {
    if (!productId) return

    router.push({
      pathname: `/product/${productId}`,
      query: {
        skuId,
        quantity: amount || 1,
      },
      state: {
        origin: 'cart',
      },
    })
  }

  return (
    <div
      onClick={goToProductPage}
      className={`br2 b--muted-4 pa3 ba inline-flex flex-row dib ${
        productId ? 'pointer' : ''
      }`}
    >
      <div className="w3 h3 mr3 relative flex justify-center items-center">
        <img src={imageSrc} alt="" className="" />
      </div>
      <div className="flex flex-column justify-between w4">
        <div className="t-small truncate">{name}</div>
        {amount > 0 && totalPrice ? (
          <div className="t-mini flex flex-row truncate">
            {`${amount} un (`}
            <Price
              value={totalPrice / amount}
              className="t-mini c-muted-2 mr1"
            />
            {<FormattedMessage id="insights.perUnit" />}
            {')'}
          </div>
        ) : (
          showStartingAt && (
            <span className="c-muted-2 f7">
              <FormattedMessage id="insights.startingAt" />
            </span>
          )
        )}
        {totalPrice && <Price value={totalPrice} className="c-on-base b" />}
      </div>
    </div>
  )
}

Item.propTypes = {
  name: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  totalPrice: PropTypes.number,
  amount: PropTypes.number,
  showStartingAt: PropTypes.bool,
  productId: PropTypes.string,
  skuId: PropTypes.string,
  router: PropTypes.object,
}

export default withRouter(Item)
